import React, { useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import i18next from "i18next";
import { StoreInterfaces } from "../../../types/store/StoreInterfaces";
import { setLanguage } from "../../../store/UI";
import { useUserPreferences } from "../../../hooks/Preferences/useUserPreferences";
import { UserPreferences } from "../../../types/ui";

const LANGUAGES = [
  { code: "en", label: "English", flag: "/flags/gb.png" },
  { code: "pt", label: "Português", flag: "/flags/pt.png" },
  { code: "es", label: "Español", flag: "/flags/es.png" },
];

const LanguagePicker = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector((state: StoreInterfaces) => state.ui.language);
  const { preferences, updatePreferences } = useUserPreferences();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language: string) => {
    dispatch(setLanguage(language));
    i18next.changeLanguage(language);
    localStorage.setItem("language", language);
    updatePreferences({
      ...preferences,
      language: language as UserPreferences["language"],
    });
    handleClose();
  };

  const currentFlag = LANGUAGES.find((lang) => lang.code === currentLanguage)?.flag ?? "/flags/gb.png";

  return (
    <>
      <IconButton onClick={handleClick} color="inherit">
        <Box
          component="img"
          src={currentFlag}
          alt="Current language"
          sx={{
            width: 24,
            height: 16,
            objectFit: "cover",
            borderRadius: 0.5,
            boxShadow: (theme) => `0 0 0 1px ${theme.palette.divider}`,
          }}
        />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {LANGUAGES.map((lang) => (
          <MenuItem key={lang.code} onClick={() => handleLanguageChange(lang.code)}>
            <Box
              component="img"
              src={lang.flag}
              alt={lang.label}
              sx={{
                width: 24,
                height: 16,
                objectFit: "cover",
                borderRadius: 0.5,
                boxShadow: (theme) => `0 0 0 1px ${theme.palette.divider}`,
                mr: 1.25,
              }}
            />
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguagePicker;